export type OverlayAction = 'none' | 'move' | 'zoom';
